/* jshint esversion: 6 */
/* jshint ignore:start */
import React, { useEffect, useState, useContext } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";
import Login from "./LoginComponent/Login";
import { ToastContainer } from "react-toastify";
import PhoneNum from "./MobilComponent/PhoneNum";
import Birthdate from "./MobilComponent/Birthdate";
import Gender from "./MobilComponent/Gender";
import Golas from "./MobilComponent/Goals";
import Nearby from "./MobilComponent/Nearby";
import Hobbies from "./MobilComponent/Hobbies";
import Languages from "./MobilComponent/Languages";
import Religion from "./MobilComponent/Religion";
import Gender2 from "./MobilComponent/Gender-2";
import Image from "./MobilComponent/Image";
import Home from "./MobilComponent/Home";
import Header from "./LoginComponent/Header";
import Detail from "./LoginComponent/Detail";
import Favorites from "./LoginComponent/Favorites";
import Profile from "./LoginComponent/Profile";
import Wallet from "./LoginComponent/Wallet";
import Upgrade from "./LoginComponent/Upgrade";
import BuyCoin from "./LoginComponent/BuyCoin";
import MyGift from "./LoginComponent/MyGift";
import CallHistory from "./LoginComponent/CallHistory";
import History from "./LoginComponent/History";
import BlockUser from "./LoginComponent/BlockUser";
import { MyProvider, MyContext } from "./Context/MyProvider";
import NotFound from "./NotFound";
import Pages from "./LoginComponent/Pages";
import Razorpay from "./PaymentMethod/Razorpay";
import PayPal from "./PaymentMethod/PayPal";
import Payment from "./PaymentMethod/Payment";
import Payfast from "./PaymentMethod/Payfast";
import Success, { Cancel } from "./PaymentMethod/Success";
import { TodoContext } from "./Context";
import UserChat from "./LoginComponent/UserChat";
import NotificationShow from "./LoginComponent/NotificationShow";
import Dashboard from "./LoginComponent/Dashboard";
import Register from "./MobilComponent/Register";
import Settings from "./LoginComponent/Settings";
import MapScreen from "./LoginComponent/MapScreen";
import Validate from "./MobilComponent/Validate";
import PaymentRespons from "./PaymentMethod/PaymentRespons";
import LocationImg from "./images/backgrounds/permission.png";
import { useTranslation } from "react-i18next";
import { showTost } from "./showTost";
import GlobalChatWidget from "./LoginComponent/GlobalChatWidget";
import MaintenanceMode from "./LoginComponent/MaintenanceMode";
import NotificationBellWidget from "./LoginComponent/NotificationBellWidget";

const MainAppRouter = () => {
  const { isMaintenanceMode } = useContext(MyContext);
  const isAuthenticated = localStorage.getItem("token");

  if (isMaintenanceMode) {
    return <MaintenanceMode />;
  }

  return (
    <Router>
      {isAuthenticated && <Header />}
      {isAuthenticated && <NotificationBellWidget />}
      <GlobalChatWidget />
      <Routes>
        {isAuthenticated ? (
          <Route path="/" element={<Dashboard />} />
        ) : (
          <Route path="/" element={<Home />} />
        )}
        <Route path="/register" element={<Register />} />
        <Route path="/phonenumber" element={<PhoneNum />} />
        <Route path="/birthdate" element={<Birthdate />} />
        <Route path="/gender" element={<Gender />} />
        <Route path="/golas" element={<Golas />} />
        <Route path="/nearby" element={<Nearby />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/hobbies" element={<Hobbies />} />
        <Route path="/languages" element={<Languages />} />
        <Route path="/religion" element={<Religion />} />
        <Route path="/preference" element={<Gender2 />} />
        <Route path="/image" element={<Image />} />
        <Route path="/login" element={<Login />} />
        <Route path="/home" element={<Home />} />
        <Route path="/wallet" element={<Wallet />} />
        <Route path="/detail/:name" element={<Detail />} />
        <Route path="/explore" element={<Favorites />} />
        <Route path="/map" element={<MapScreen />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/upgrade" element={<Upgrade />} />
        <Route path="/buyCoin" element={<BuyCoin />} />
        <Route path="/mygift" element={<MyGift />} />
        <Route path="/callhistory" element={<CallHistory />} />
        <Route path="/history" element={<History />} />
        <Route path="/blockUser" element={<BlockUser />} />
        <Route path="/page/:title" element={<Pages />} />
        <Route path="/razorpay" element={<Razorpay />} />
        <Route path="/paypal" element={<PayPal />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/payfast" element={<Payfast />} />
        <Route path="/done" element={<Success />} />
        <Route path="/cancel" element={<Cancel />} />
        <Route path="/chat" element={<UserChat />} />
        <Route path="/setting" element={<Settings />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/validate" element={<Validate />} />
        <Route path="/PaymentRespons" element={<PaymentRespons />} />
        <Route path="/notification" element={<NotificationShow />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

const App = () => {
  const { t } = useTranslation();
  const [demo, setDemo] = useState();
  const [locationError, setLocationError] = useState(false);

  const dismissLocationPrompt = () => {
    localStorage.setItem("location_prompt_dismissed", "true");
    setLocationError(false);
  };

  const requestBrowserLocation = () => {
    if (!navigator.geolocation) {
      setLocationError(true);
      showTost({ title: "Location is not supported by this browser." });
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        localStorage.setItem("user_latitude", String(position.coords.latitude));
        localStorage.setItem("user_longitude", String(position.coords.longitude));
        localStorage.removeItem("location_prompt_dismissed");
        setLocationError(false);
        showTost({ title: "Location enabled successfully." });
      },
      (error) => {
        setLocationError(true);
        const title =
          error.code === error.PERMISSION_DENIED
            ? "Location permission denied. Enable it in browser settings and try again."
            : "Unable to capture location. Please turn on location service and try again.";
        showTost({ title });
      }
    );
  };

  useEffect(() => {
    if (localStorage.getItem("location_prompt_dismissed") === "true") {
      return;
    }
    if (!navigator.geolocation) {
      setLocationError(true);
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (position) => {
        localStorage.setItem("user_latitude", String(position.coords.latitude));
        localStorage.setItem("user_longitude", String(position.coords.longitude));
        setLocationError(false);
      },
      () => setLocationError(true)
    );
  }, []);

  return (
    <div>
      <MyProvider>
        <TodoContext.Provider value={{ demo, setDemo }}>
          <MainAppRouter />
        </TodoContext.Provider>
      </MyProvider>

      {locationError && (
        <div className="px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
          <div className="w-[25%] max-_430_:w-[100%] max-_768_:w-[75%] max-_1030_:w-[35%] max-_1500_:w-[25%] bg-white rounded-[15px] px-[15px] py-[10px] relative">
            <button
              type="button"
              onClick={dismissLocationPrompt}
              className="absolute right-[12px] top-[10px] w-[30px] h-[30px] rounded-full bg-[#f5e8ff] text-[#980EFF] font-[700] leading-[30px]"
              aria-label="Close location prompt"
            >
              ×
            </button>
            <div className="">
              <h2 className="m-0 text-center">{t('Enable Location Services')}</h2>
              <img src={LocationImg} alt="" />
              <div className="my-3">
                <div className="flex gap-[10px]">
                  <span className="text-[18px]">1.</span>
                  <h6>To provide accurate services, please enable your location.</h6>
                </div>
                <div className="flex gap-[5px]">
                  <span className="text-[18px]">2.</span>
                  <h6> Allow location access when prompted. If not prompted, enable it in your browser settings.</h6>
                </div>
                <h6>{t("You can skip now and add location later from profile.")}</h6>
              </div>
              <button onClick={requestBrowserLocation} className="bg-[#980EFF] text-white w-[100%] rounded-[5px] py-[5px] mt-2 font-[500]">Enable Now</button>
              <button
                type="button"
                onClick={dismissLocationPrompt}
                className="bg-[#f5e8ff] text-[#980EFF] w-[100%] rounded-[5px] py-[5px] mt-2 font-[600]"
              >
                {t("Skip for now")}
              </button>
            </div>
          </div>
        </div>
      )}

      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
};

export default App;
/* jshint ignore:end */
